import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import classes from './FormItemLabel.module.less';
import './FormItemLabel.less';

type FormItemLabelProps = {
  hasError?: boolean;
  translationKey?: string;
  isActive: boolean;
  disabled?: boolean;
  optional?: boolean;
  requiredTooltipKey?: string;
};

const FormItemLabel: FC<FormItemLabelProps> = ({
  hasError,
  translationKey,
  isActive,
  disabled,
  optional,
  requiredTooltipKey,
}) => {
  const { t } = useTranslation();
  const label = translationKey ? t(translationKey) : '';
  const requiredTooltip = requiredTooltipKey && t(requiredTooltipKey);

  // Kolor zależy od tła: ekrany przed logowaniem ustawiają złoty na szarą ścianę (--form-label-color
  // w AppContent), w okienkach na płótnie i w kartach słów zostaje ciemne złoto
  return (
    <span
      className={classNames({
        [classes.error]: hasError,
        [classes.active]: isActive && !hasError,
        [classes.disabled]: disabled,
      })}
      style={{ color: 'var(--form-label-color, darkgoldenrod)', fontSize: '0.8rem' }}
    >
      {requiredTooltip ? (
        <Tooltip title={requiredTooltip} trigger="hover" placement="right">
          <span className={classes.required}>{label}</span>
        </Tooltip>
      ) : label}{' '}
      {optional ? (
        <span
          className={classNames({
            [classes.disabled]: !isActive,
          })}
        >
          ({t('common:labels.optional')})
        </span>
      ) : <span />}
    </span>
  );
};

export default FormItemLabel;
